const StrmClass: React.FC = () => {
  const finalUrl =
    "https://fundraising.strmmusic.ai/auth/login?crstk=MS06ODg5Mjo4OTI4NjczMTpidmVuaGZoOjpwNnFwcG5uNTJuMjJxMnI1MDJvMTEwcTI5bnFwMXJucA%3D%3D";

  if (!finalUrl) return null;
  return (
    <div
      style={{ width: "100%", height: "100%", minHeight: "100vh" }}
      className="strm-class"
    >
      <iframe
        style={{ width: "100%", height: "100vh" }}
        src={finalUrl}
        title="strm-class"
        id="strm-class-iframe"
      />
    </div>
  );
};

export default StrmClass;
